module.exports = __webpack_public_path__ + "img/review-response-generator.b246990c.png";